import { Link } from "react-router-dom";
import InfoLayout from "@/components/InfoLayout";
import InlineCTA from "@/components/InlineCTA";
import { FAQS, ALL_FAQS, SITE_URL } from "@/seo/data";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";

export default function FAQPage() {
  const title = "Häufige Fragen | Autoglas, Steinschlag & Versicherung — Rhein-Neckar";
  const description = "Antworten auf die häufigsten Fragen zu Steinschlagreparatur, Frontscheibentausch, Versicherungsabwicklung, Kosten, ADAS-Kalibrierung und Terminbuchung in Mannheim und Umgebung.";
  const canonical = `${SITE_URL}/faq`;

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQS.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <InfoLayout title={title} description={description} canonical={canonical} jsonLd={jsonLd}>
      <h1>Häufige Fragen rund um Autoglas, Steinschlag & Versicherung</h1>
      <p className="lead">
        Hier finden Sie Antworten auf die wichtigsten Fragen zu Steinschlagreparatur, Scheibentausch,
        Versicherungsabwicklung und Terminbuchung. Wenn Sie Ihre Antwort nicht finden, nutzen Sie gerne
        unseren KI-Chatbot unten rechts oder rufen uns direkt an.
      </p>

      <div className="not-prose my-8">
        <Accordion type="single" collapsible className="space-y-2">
          {ALL_FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="bg-white border border-slate-200 rounded-xl px-5 data-[state=open]:border-blue-400"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="text-left font-semibold text-slate-900 hover:no-underline py-4">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-700 leading-relaxed pb-4">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>

      <InlineCTA variant="dark" />

      <h2>Mehr Informationen</h2>
      <ul>
        <li><Link to="/leistungen">Alle Leistungen im Überblick</Link></li>
        <li><Link to="/versicherungen">Direktabwicklung mit allen Versicherungen</Link></li>
        <li><Link to="/leistung/steinschlagreparatur">Steinschlagreparatur — Ablauf und Kosten</Link></li>
        <li><Link to="/leistung/adas-kalibrierung">ADAS-Kalibrierung erklärt</Link></li>
      </ul>
    </InfoLayout>
  );
}
